/** @jsx jsx */

import { jsx } from '@emotion/react';
import Box from '@atlaskit/ds-explorations/box';
/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */
var NavigationFooter = function NavigationFooter(_ref) {
  var children = _ref.children;
  return jsx(Box, {
    display: "block",
    position: "relative",
    padding: "space.100",
    UNSAFE_style: {
      paddingBottom: "var(--ds-space-200, 14px)"
    }
  }, children);
};
export default NavigationFooter;